import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=00f2cb0d&"
import script from "./SuccessPage.vue?vue&type=script&lang=js&"
export * from "./SuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports